<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-lg-6 vcenter">
      <h3>Scheduled Maintenance Generator</h3>
    </div>

  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />
  <div class="row top10">
    <div class="col-xs-11">
      <aims-common-button aria-label="Generate Scheduled Maintenances"
        (click)="runScheduledMaintenanceGenerator()">
        <mat-icon>work</mat-icon>
        Generate Scheduled Maintenances
      </aims-common-button>
    </div>
  </div>
   <div class="row top10">
    <div class="col-xs-11">
      <aims-common-button *ngIf="isAimsAdmin"
        (click)="migrateLineItemImages()">
        <mat-icon>work</mat-icon>
        Migrate LI Images
      </aims-common-button>
    </div>
  </div>
  <!-- </div>
   <div class="row top10">
    <div class="col-xs-11">
      <button class="btn btn-default" (click)="runPOTest()">Run PO Test</button><ng-container *ngIf="runTest | async">Running...</ng-container>
    </div>
    <div class="col-xs-11">
      <button class="btn btn-default" (click)="stopPOTest()">Stop PO Test</button>
    </div>
  </div>
  <ng-container *ngIf="numberOfLoops > 0">Number Of Loops: {{numberOfLoops}}</ng-container>
  <div *ngFor="let poString of poTestRetVal">
    {{poString}}
  </div>

  <div class="row top10">
    <div class="col-xs-11">
      <button class="btn btn-default" (click)="addClassHist()">Add Classification History</button>
    </div>
  </div>
  <div class="row top10">
    <div class="col-xs-11">
      <button class="btn btn-default" (click)="addUsers()">Generate Users With Temp Passwords</button>
    </div>
  </div> -->
  <!--<div class="row top10">
    <div class="col-xs-11">
      <button class="btn btn-default" (click)="create332s()">Generate 332s</button>
    </div>
  </div>-->

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
